import texts from "./Constants";

const defaultImageAlt = ( string, type="postTitle" ) =>
{
    const prefix = texts[type]?.prefix || '';
    const suffix = texts[type]?.suffix || '';
    return `${prefix}${string}${suffix}`;
}

export default defaultImageAlt;